export default "__VITE_ASSET__691cf456__"